import type { CaseCopy } from "./types";
import { bpi2017 } from "./bpi-2017";
import { roadTraffic } from "./road-traffic";
import { sepsis } from "./sepsis";
import { helpdesk } from "./helpdesk";

/* Canonical registry of authored case copy. Order matters: it drives
   numbering (I–IV) in the right-rail and the mastheadIssue labels. */
export const CASE_COPY: CaseCopy[] = [
  bpi2017,
  roadTraffic,
  sepsis,
  helpdesk,
];

const BY_SLUG: Record<string, CaseCopy> = CASE_COPY.reduce<Record<string, CaseCopy>>((acc, c) => {
  acc[c.slug] = c;
  return acc;
}, {});

export function getCaseCopy(slug: string): CaseCopy | undefined {
  return BY_SLUG[slug];
}

/** The four real-dataset slugs, in portfolio order. */
export const PORTFOLIO_SLUGS = CASE_COPY.map((c) => c.slug);
